import { Alert, Box, Typography } from 'hephaestus/web';
import { Info as InfoIcon } from 'hephaestus/webIcons';
import { useTranslation } from 'react-i18next';

export type DepositExternalTransferTypeAlertsProp = {
  transferType: string;
};

export const DepositExternalTransferTypeAlerts = ({
  transferType,
}: DepositExternalTransferTypeAlertsProp) => {
  const { t } = useTranslation('workflowCompletions');

  return (
    <Box sx={{ mt: 2, mb: 2 }}>
      {transferType === 'ALL_IN_CASH' && (
        <Alert variant='outlined' icon={<InfoIcon />} severity='info'>
          <Typography variant='bodySmall' component='p'>
            {t('depositReview.allInCashMessage')}
          </Typography>
        </Alert>
      )}
      {transferType === 'PARTIAL_CASH' && (
        <Alert variant='outlined' icon={<InfoIcon />} severity='info'>
          <Typography variant='bodySmall' component='p'>
            {t('depositReview.partialCashMessage')}
          </Typography>
        </Alert>
      )}
      {transferType === 'ALL_IN_KIND' && (
        <Alert variant='outlined' icon={<InfoIcon />} severity='info'>
          <Typography variant='bodySmall' component='p'>
            {t('depositReview.allInKindMessage')}
          </Typography>
        </Alert>
      )}
    </Box>
  );
};
